import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Spinner from '../components/Spinner';
import { isAdminEmail } from '../utils/isAdmin';
import * as routes from '../constants/routes';

const AdminRoute = ({ firebase }) => {
  const user = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, [user]);

  if (isLoading) {
    return <Spinner />;
  }

  if (!user) {
    return <Navigate to={routes.SIGN_IN} replace />;
  }

  const email = user.email || firebase?.auth?.currentUser?.email;
  if (!isAdminEmail(email)) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Access denied</h2>
        <p>Only admin accounts can access this page.</p>
      </div>
    );
  }

  return <Outlet />;
};

export default AdminRoute;
